import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DropdownQuestion } from '../../../classes/question-dropdown';

@Component({
  selector: 'bepatient-input-dropdown',
  templateUrl: './input-dropdown.component.html',
  styleUrls: ['./input-dropdown.component.scss'],
  standalone: false
})
export class InputDropdownComponent {
  @Input() question: DropdownQuestion;
  @Input() parent: UntypedFormGroup;

  customPopoverOptions: any = {
    cssClass: 'bepatient_dynamic_form_popover'
  };
}
